require('./style.less');


var Marionette = require('marionette');

module.exports = Marionette.ItemView.extend({

    template: require('./template.hbs'),

    serializeData: function() {

        return {
            numberHits: this.options.numberHits,
            numberAppliedHits: this.options.numberAppliedHits
        };

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/hitSelectedCount/view.js
 ** module id = 621
 ** module chunks = 0
 **/